import { EnvConfig } from './env-config';

const API_URL = 'http://localhost:5000/api/v1'; // LOCAL
// const API_URL = 'https://uat-returns.inretrn.com/api/v1'; // STAGING
// const API_URL = 'https://returns.inretrn.com/api/v1'; // PRODUCTION

export const BASE_URL = process.env.NODE_ENV === 'development' ? API_URL : EnvConfig.API_URL;
